module.exports = __webpack_public_path__ + "img/new-client.1ffffd21.svg";